import { SheetDto } from './';
import { ColumnDto } from './';

export class RowDto {
    rowId: number;
    sheetId: string;
    sheet: SheetDto;
    columnsDto: ColumnDto[]=[];
}